
require(["readium_plugin_hypothesis", "readium_shared_js/globalsSetup", "readium_js_viewer/ReadiumViewer"]);
